export let colorConfig = {
    "observed flow": "#000080",
    "rainfall": "#000080",
    "historical flow": "#000080",
    "ensemble": "#c2c2c2",
    "simulated water level": "#fc0303",
    "precipitation": 'rgba(0, 0, 255, 1)',
    "tidal level forecast": "#fc0303",
    "tidal level": "#000080",
    "simulated flow": "#ff9900",
    "simulated inflow": "#800080",
    "historical water level": "#8B0000",
    "tivoli level": "#2828e0",
    "ovens simulated flow": "#0095b6",
    "inniscarra simulated outflow": "#d82429",
    "simulated forecast": "rgb(26,40,200)",
    "updated flow": "rgb(50,100,202)",
    "simulated historical": "rgb(26,200,90)",
    "min": "rgb(205, 154, 103,0.6)",
    "max": "rgb(255, 204, 153,0.6)",
    "choke index": "rgb(210, 122, 250)",
    "rainfall accumulation": "rgb(0,0,200)",
    "25th percentile": "rgba(255, 255, 204,0.6)",
    "75th percentile": "rgba(255, 255, 204,0.6)"
};
